import styles from './NoDataRow.module.scss'
import buttonStyles from '@styles/buttons.module.scss'

import SearchSVG from '@public/assets/search.svg'
import { SearchType } from '@prisma/client'
import Image from 'next/image'
import React from 'react'
import classNames from 'classnames'
import { useRecoilState } from 'recoil'
import { calendarPopupState } from '../../recoil/atoms'

type Props = {
  colSpan: number
  error?: boolean
  resultType?: SearchType
}

const NoDataRow: React.FC<Props> = ({ colSpan, resultType, error = false }) => {
  return (
    <tr className={`${styles.noData} ${error ? styles.error : ''}`}>
      <td colSpan={colSpan}>
        {resultType === SearchType.UPDATE_EXISTING ? (
          <div className={styles.wrapper}>
            <Image
              src="/assets/no_results_dates.svg"
              alt="No results"
              width={200}
              height={200}
            />
            <div className={styles.mainText}>
              The exclusion filter you selected does not have any keywords your
              are ranking for organically on Google.
            </div>
            <button
              className={classNames(buttonStyles.btn, buttonStyles.yellow)}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              Adjust exclusion filter
            </button>
          </div>
        ) : (
          <p className={styles.no_data_text}>
            <SearchSVG />
            {error ? 'Failed to load data' : 'Nothing to display'}
          </p>
        )}
      </td>
    </tr>
  )
}

export default NoDataRow
